<template>
    <div class='cnt_box'>
        <!-- 顶部title -->

        <div class="cnt_top_box" :style="{
            'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
            'backgroundColor': '#f5f5f5' // 添加备用背景色
        }">
            <!-- <div class="boxbox_img">
                <img src="../assets/img/ba.png" alt="" class="back" @click="back">
            </div> -->
            <div class="flex">
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <div class="right_top_box">
                    <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                    <!-- <div class="right_top_txt_shu">|</div>
                    <Kefu :sn='sn'></Kefu> -->
                </div>
            </div>
            <img class="jindu" v-if="$i18n.locale == 'en'" src="../assets/img/cnt_top_jindu.png" alt="">
            <!-- <img class="jindu" v-else src="../assets/img/cnt_top_jindu_cn.png" alt=""> -->
            <div v-else>
                <img class="jindu1" v-if="carbonFootprint" src="../assets/img/iscou.png" alt="">
                <img class="jindu1" v-else src="../assets/img/nocou.png" alt="">
            </div>
            <div class="cnt_flex">
                <div class="cnt_num_box">
                    <p>{{ carbonFootprint }}</p>
                    <span>kgCO₂e</span>
                </div>
                <div class="cnt_top_title">{{ $t('TotalCarbonFootprint') }}</div>
                <div class="cnt_top_div">
                    <div class="border_box">
                        <el-date-picker v-model="datetonnestart" @change="serchList(1)" :picker-options="pickerOptions"
                            format="yyyy - MM - dd" value-format="yyyy-MM-dd" :placeholder="$t('Stat')">
                        </el-date-picker>
                        {{ $t('To') }}
                        <el-date-picker v-model="datetonnesend" @change="serchList(2)" :picker-options="pickerOptions1"
                            format="yyyy - MM - dd" value-format="yyyy-MM-dd" :placeholder="$t('End')">
                        </el-date-picker>
                    </div>
                    <div class="border_box_right">
                        <div class="txt_border_box">{{ $t('totalemission') }}</div>
                        <div class="txt_border_tit">{{ carconNum }}</div>
                        <div class="txt_border_banner">kgCO₂e</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 列表区 -->
        <div class="cnt_banner">
            <div v-for="(item, index) in carList" :key="index">
                <div class="list_box">
                    <el-row type="flex" justify="space-between">
                        <el-col class="left_txt lt_txt">{{ getDefaultDatenew(item.date) }}</el-col>
                        <el-col class="right_txt rt_txt">{{ (Number(item.tripsCarbon || 0) + Number(item.staysCarbon || 0)).toFixed(2) }}<span
                                class="ton_txt gr_txt">kgCO₂e</span></el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row type="flex" justify="space-between">
                        <el-col class="left_txt btm_txt">{{ $t('Trips') }}</el-col>
                        <el-col class="right_txt btm_txt">{{ item.tripsCarbon }}<span class="ton_txt">kgCO₂e</span></el-col>
                    </el-row>
                    <el-row type="flex" class="mg_box" justify="space-between">
                        <el-col class="left_txt btm_txt">{{ $t('Stays') }}</el-col>
                        <el-col class="right_txt btm_txt">{{ item.staysCarbon }}<span class="ton_txt">kgCO₂e</span></el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <!-- 按钮 -->
        <!-- <div class="btm_btn">
            <div @click="submit()">Neutralize My Carbon Footprint</div>
        </div> -->
        <!--  -->
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Kefu from '@/components/kefu.vue'
import cnt from '@/api/cnt'
import { getDefaultDate, getDefaultDatenew } from '@/util/date.js'
export default {
    name: 'carconList',
    // import引入的组件需要注入到对象中才能使用
    components: { Kefu },
    data() {
        // 这里存放数据
        return {
            carbonFootprint: 0,
            datetonnestart: '',
            datetonnesend: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },
            carconNum: '',
            sn: '',
            isShow: false,
            carList: [],
            config: '',
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.sn = this.$route.query.sn
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getCarConNum()
        this.datetonnestart = this.getDefaultDate(Date.now())
        this.datetonnesend = this.getDefaultDate(Date.now())
        this.getSingerList();
        //   this.getUserEvent(1,1)
        window.addEventListener('scroll', this.listenBottomOut)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() {
        window.removeEventListener('scroll', this.listenBottomOut, false)
    }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        getDefaultDate: getDefaultDate,
        getDefaultDatenew: getDefaultDatenew,
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        back() {
            this.$router.go(-1)
        },
        listenBottomOut() {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            const clientHeight = document.documentElement.clientHeight
            const scrollHeight = document.documentElement.scrollHeight
            if (scrollTop + clientHeight >= scrollHeight) {
                console.log(1)
                // 没有数据后，不触发请求
                if (!this.isShow) {
                    this.getSingerList()
                }
                return
            }
        },
        submit() {
            this.getUserEvent(2, 4)
            this.$router.push({ path: '/info', query: { sn: this.sn } })
        },
        serchList(type) {
            console.log(type, this.datetonnestart, this.datetonnesend)
            this.getSingerList()
        },
        getSingerList() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            let params = {
                start: this.datetonnestart,
                end: this.datetonnesend,
                userId: user.id
            }
            if (this.datetonnestart && this.datetonnesend) {
                cnt.getCarConListNum(res => {
                    if (res.code == 200) {
                        this.carconNum = res.data.historyTotal
                        this.carList = res.data.travelHistoryItemList
                    }

                }, params)
            }

        },
        //获取碳排放总量
        getCarConNum() {
            let user = JSON.parse(sessionStorage.getItem('user'))
            cnt.getCarConNum(res => {
                console.log(111, res)
                if (res.code == 200) {
                    this.carbonFootprint = res.data
                }
            }, user.id)
        }
    }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.cnt_box {
    width: 100%;
    height: 100%;
}

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 20px 0;
}

.cnt_top_box {
    width: 100%;
    // height: 338.5008px;
    height: 350px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

    .boxbox_img {
        position: absolute;
        top: 10px;
        left: 20px;
    }

    .logo {
        width: auto;
    }

    .jindu {
        width: 333.5008px;
        height: 41.5008px;
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
    }

    .jindu1{
        width: auto;
        height: 41.5008px;
        margin: 40px auto 0;
        display: flex;
        justify-content: center;
    }

    .right_top_box {
        display: flex;
        align-items: center;

        .right_top_txt {
            font-size: 12px;
            font-family: Century Gothic;
            color: #EDFFFE;
        }

        .right_top_txt_shu {
            margin: 0 12px;
            color: #EDFFFE;
        }

        .bangzhu {
            width: 17px;
            height: 17px;
        }
    }

    .cnt_top_div {
        width: 100%;
        min-height: 27px;
        border-radius: 20px 20px 0 0;
        background: #F3F4F6;
        position: absolute;
        bottom: -70px;

        // display: flex;
        // justify-content: space-between;
        // align-items:center;
        // padding: 20px;
        .border_box {
            display: flex;
            justify-content: space-around;
            align-items: center;
            // width: 163px;
            height: 40px;
            padding: 20px 20px 12px 20px;
            // background: #FFFFFF;
            border-radius: 10px;
        }

        .border_box_right {
            padding: 0 20px 11.5px 20px;
            display: flex;
            justify-content: end;
            align-items: center;

            .txt_border_box {
                font-size: 12px;
                font-family: Century Gothic;
                color: #C1C1C1;
                margin-right: 20px;
            }

            .txt_border_tit {
                font-size: 15px;
                font-family: Arial-BoldMT, Arial;
                font-weight: 600;
                color: #303236;
                margin-right: 5px;
            }

            .txt_border_banner {
                font-size: 12px;
                font-family: Century Gothic;
                color: #303236;
            }
        }
    }

    .cnt_flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 40px;

        .cnt_num_box {
            display: flex;

            p {
                font-size: 49px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #FFFFFF;
                line-height: 44px;
            }

            span {
                font-size: 12px;
                font-family: Century Gothic;
                color: #FFFFFF;
                margin: 24px 0 0 5px;
            }
        }

        .cnt_top_title {
            font-size: 13px;
            font-family: Century Gothic;
            color: #FFFFFF;
            margin-top: 4.5008px;
        }
    }

}

.cnt_banner {
    padding: 0px 20px 40px 20px;
    min-height: 450px;
    background: #F3F4F6;
    margin-top: 70px;

    .list_box {
        width: 307px;
        height: 116px;
        background: #FFFFFF;
        border-radius: 20px;
        padding: 25px 14px;
        margin: 0 auto 20px;

        .mg_box {
            margin-top: 22.5px;
        }

        .el-divider--horizontal {
            margin: 16px 0;
        }

        .left_txt {
            text-align: left;
        }

        .lt_txt {
            font-size: 15px;
            font-family: Century Gothic;
            color: #8F8F8F;
        }

        .btm_txt {
            font-size: 15px;
            font-family: Century Gothic;
            color: #303236;
        }

        .rt_txt {
            font-size: 15px;
            font-family: Arial-BoldMT, Arial;
            font-weight: 600;
            color: #4D94A0;
        }

        .gr_txt {
            color: #4D94A0 !important;
            font-weight: normal;
        }

        .right_txt {
            text-align: right;

            .ton_txt {
                margin-left: 4px;
                font-size: 12px;
                font-family: Century Gothic;
                color: #303236;
            }
        }
    }
}

.back {
    width: .8125rem;
    height: 1.375rem;
    //   margin: 2.5rem 1.25rem 0;
}

.btm_btn {
    // margin-top: 40px;
    padding-bottom: 40px;
    position: fixed;
    bottom: 0;
    left: calc((100% - 335px) / 2);
    right: auto;

    div {
        cursor: pointer;
        display: flex;
        justify-content: center;
        width: 335px;
        height: 45px;
        background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
        box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
        border-radius: 10px;
        text-align: center;
        line-height: 45px;
        font-size: 15px;
        font-family: Century Gothic;
        color: #FFFFFF;
    }
}
</style>
